import Service from '@root/common/base/Service';
import { ServiceInterface } from '@root/common/types/service';

import { GetMostReadArticles } from '@root/modules/headlines/types/headlines';
import getMostReadArticles from '@root/modules/headlines/graphql/getMostReadArticles.graphql';

type ServiceVariables = GetMostReadArticles['variables'];

type FetchVariables = GetMostReadArticles['variables'];

type Response = GetMostReadArticles['data'];

export default class MostReadArticlesService extends Service implements ServiceInterface {
  private async fetchMostReadArticles(variables: FetchVariables) {
    try {
      const apiProvider = this.createProvider('GraphQL');
      apiProvider
        .selectAPI('content-api-v3')
        .setLinkOptions({ useAutomaticPersistedQueries: true, useGETAutomaticPersistedQueries: true })
        .setCacheOptions({ key: `fetchMostReadArticles:${JSON.stringify(variables)}`, ttl: 30 })
        .enableCache(true);

      const options = Object.assign({ query: getMostReadArticles }, { variables });
      const response = await apiProvider.request<Response>(options);

      return response.headlines?.items || [];
    } catch {
      return [];
    }
  }

  public async fetch(variables: ServiceVariables) {
    const isHealthy = this.getHealthCheckStatus('content-api-v3');

    if (!isHealthy) {
      return [];
    }

    const response = await this.fetchMostReadArticles(variables);

    return response;
  }
}
